import Kline from './js/kline'

window.Kline = Kline;

export default Kline



// WEBPACK FOOTER //
// ./src/entry.js